// dictionary(字典)插件服务

import { CORE_PLUGIN } from "@/core"
import type { ConsolePageOption, ConsolePageService, Plugin } from "@/plugins"
import { injectOptional } from "@/tsyringe-extend"
import { defineStore } from "pinia"
import { container, injectable, instanceCachingFactory, registry, singleton } from "tsyringe"
import type { RouteRecordRaw } from "vue-router"
import { PLUGIN_CONSOLE_PAGE, PLUGIN_DICTIONARY } from "../../builtin/BuiltinPluginSymbol"
import { dictionaryEntryList } from './service/DictionaryService'
import type { DictionaryEntrySingle } from './service/type/DictionaryType'
import MainVue from './view/DictionaryMain.vue'


export const DictionaryPageOptionsInjectKey = 'DictionaryPageOptionsInjectKey'


export type DictionaryPageOption = {
  disabled: boolean
  dictionarySingleId: string
  dictionarySingleKey: string
}

export interface DictionaryService {
  //
  getItems(key: string): Promise<DictionaryEntrySingle[]>
}

const createState = (): DictionaryPageOption => {
  return {
    dictionarySingleId: '',
    dictionarySingleKey: '',
    disabled: false
  }
}

export const dictionaryStore = defineStore('dictionaryStore', {
  state: createState,
  actions: {
    async getItems(key: string) {
      const res = await dictionaryEntryList(key)
      return res.items
    }
  }
})

@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<DictionaryPageOption, DictionaryService>>((c) => c.resolve(DictionaryPlugin))
  }
])
@registry([
  {
    token: PLUGIN_DICTIONARY,
    useFactory: instanceCachingFactory<Plugin<DictionaryPageOption, DictionaryService>>((c) => c.resolve(DictionaryPlugin))
  }
])
@injectable()
export class DictionaryPlugin implements Plugin<DictionaryPageOption, DictionaryService> {
  id: string | symbol = PLUGIN_DICTIONARY
  options: DictionaryPageOption
  service: DictionaryService
  constructor(
    @injectOptional(DictionaryPageOptionsInjectKey)
    options: DictionaryPageOption
  ) {
    const instantiationStore = dictionaryStore()
    this.service = instantiationStore
    this.options = instantiationStore.$state
    if (options) {
      instantiationStore.$patch(options)
    }
  }

  init(): void {
    // container.register<DictionaryService>(PLUGIN_DICTIONARY, { useValue: this.service })
    const { disabled } = this.options
    if (disabled) {
      const plugin = container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(PLUGIN_CONSOLE_PAGE)
      const Routes = [
        { name: "dictionaries", path: "system/dictionaries", component: MainVue },
      ] as RouteRecordRaw[]
      Routes.forEach(r => {
        plugin.service.addChildRoute(r)
      })
    }
  }

  initialized(): void {
    //
  }
}
